import { render } from "./AdminColorCode.vue?vue&type=template&id=db1c64c0"
import script from "./AdminColorCode.vue?vue&type=script&lang=js"
export * from "./AdminColorCode.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__